import { useFormContext } from "react-hook-form";
import PortalSearchTable from "../../common/table/PortalSearchTable";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import React from "react";
import { useTranslation } from "react-i18next";
import { OptionTableCell, TableButton } from "@duosoftbg/nacid-components";

const headCells = [
  {
    id: "number",
    label: "l.table.head.number",
    sortable: false,
  },
  {
    id: "name",
    label: "l.table.head.person.name",
  },
  {
    id: "username",
    label: "l.table.head.username",
  },
  {
    id: "email",
    label: "l.table.head.email",
  },
  {
    id: "enabled",
    label: "l.table.head.enabled",
    sortable: false,
  },
  {
    id: "emailVerified",
    label: "l.table.head.emailVerified",
    sortable: false,
  },
  {
    id: "options",
    label: "",
    sortable: false,
  },
];

const UsersListTable = ({ records, total, onPageOrOrderChange, blockTable, group }) => {
  const { getValues } = useFormContext();
  const { t } = useTranslation();

  return (
    <>
      <PortalSearchTable
        group={group}
        headCells={headCells}
        total={total}
        blockTable={blockTable}
        onPageOrOrderChange={onPageOrOrderChange}
      >
        <TableBody>
          {records.map((row, index) => {
            return (
              <TableRow hover key={row.id}>
                <TableCell>{index + 1 + getValues().page * getValues().pageSize}</TableCell>
                <TableCell>{row.fullName}</TableCell>
                <TableCell>{row.username}</TableCell>
                <TableCell>{row.email}</TableCell>
                <TableCell>{row.enabled ? t("l.yes") : t("l.no")}</TableCell>
                <TableCell>{row.emailVerified ? t("l.yes") : t("l.no")}</TableCell>
                <OptionTableCell>
                  <TableButton type={"view"} to={`view?id=${row.id}`} />
                  <TableButton type={"edit"} to={`edit?id=${row.id}`} />
                </OptionTableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </PortalSearchTable>
    </>
  );
};

export default UsersListTable;
